import i18next, { TFunction } from 'i18next';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zh_CN from './zh-CN.json';
import en_US from './en-US.json';

class Intl {
  static instance: Intl;
  constructor() {
    const lang = this.getLanguage();

    i18next.init({
      lng: lang,
      debug: true,
      resources: {
        'zh-CN': {
          translation: zh_CN,
        },
        'en-US': {
          translation: en_US,
        },
      },
      fallbackLng: 'zh-CN',
    });
    this.updateLibrary(lang);
  }

  updateLibrary = (lang: string) => {
    if (lang === 'zh-CN') {
      dayjs.locale('zh-cn');
    } else {
      dayjs.locale('en');
    }
  };

  // TODO: 临时修改为中文
  getLanguage = () => 'zh-CN';
  setLanguage = (lang: string) => {
    // i18next.changeLanguage(lang, (err) => {
    //   if (err) {
    //     return false;
    //   }
    //   this.updateLibrary(lang);
    //   window.localStorage.setItem('marioLocale', lang);
    //   location.reload();
    //   return true;
    // });
  };

  static getInstance = () => {
    if (!Intl.instance) {
      Intl.instance = new Intl();
    }

    return Intl.instance;
  };
  ready = (fn: () => void) => {
    i18next.init((err) => {
      if (err) return;
      fn && fn();
    });
  };
  t: TFunction = function (...args: Parameters<typeof i18next.t>) {
    return i18next.t(...args);
  };
  getAntdLanguage = () => {
    const lang = this.getLanguage();
    return lang === 'zh-CN' ? zhCN : enUS;
  };
}

export const intl = Intl.getInstance();

export const isZh = () => intl.getLanguage() === 'zh-CN';

export default intl;
